"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconAnchor = function SvgIconAnchor(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "currentColor",
    "aria-label": "anchor icon",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Anchor Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 44C10.304 44 4 30 4 26h8l-3.633 2.422c1.158 1.217 4.997 4.687 10.844 6.034L21.182 20H16v-4h5.727l.058-.422a6.004 6.004 0 01-3.78-5.353L18 10a6 6 0 118.147 5.604l.035.396H32v4h-5.454l1.332 14.645c6.22-1.15 10.352-4.779 11.67-6.135L36 26h8c0 4-6.304 18-20 18zm0-36c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
  }));
};

var _default = SvgIconAnchor;
exports.default = _default;